<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.LOADING.START"
    :handler="() => $refs.modal.show()"
  />

  <VBusHelper
    :reactOn="$constants.EVENTS.LOADING.FINISH"
    :handler="() => $refs.modal.hide()"
  />

  <DialogComponent ref="modal" type="ui-less" v-slot="{ dialogVisible }">
    <Transition name="fade">
      <div
        v-if="dialogVisible"
        class="h-full w-full fixed z-100 top-0 left-0 flex items-center justify-center p-6"
      >
        <div class="loaderrr"></div>
      </div>
    </Transition>
  </DialogComponent>
</template>

<style scoped>
.loaderrr {
  width: 60px;
  height: 60px;
  border: 5px solid rgba(200, 200, 200, 0.3);
  border-top-color: #FF7200;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>